const TARGET_CITY_NAME = "Onomichi";
const APP_ID = "dc8153d85c08b9d8b5a50d4660cdf8e2";
const BASE_URL = "https://api.openweathermap.org/data/2.5/weather";

/**
 * 天気データをキャッシュ付きで管理するクラスだよ！
 */
class WeatherCache {
    static CACHE_KEY = "weather_cache";
    static CACHE_DURATION = 12 * 60 * 60 * 1000; // 12時間をミリ秒で表現

    /**
     * キャッシュされた天気データを取得するよ
     * @returns {Promise<WeatherData | null>} 天気データまたはnull
     */
    static async getWeatherData() {
        const cached = localStorage.getItem(this.CACHE_KEY);

        if (cached) {
            const { data, timestamp } = JSON.parse(cached);

            // キャッシュが有効期限内かチェック
            if (Date.now() - timestamp < this.CACHE_DURATION) {
                return data;
            }
            // 期限切れならキャッシュを削除
            localStorage.removeItem(this.CACHE_KEY);
        }
        return null;
    }

    /**
     * 天気データをキャッシュに保存するよ
     * @param {WeatherData} data - 保存する天気データ
     */
    static setWeatherData(data) {
        const cacheData = {
            data,
            timestamp: Date.now(),
        };
        localStorage.setItem(this.CACHE_KEY, JSON.stringify(cacheData));
    }
}

/**
 * 天気情報を表示する関数だよ
 */
export const showWeather = async () => {
    try {
        // まずキャッシュをチェック
        let weatherData = await WeatherCache.getWeatherData();

        if (!weatherData) {
            // キャッシュがなければAPIから取得
            const response = await fetch(
                `${BASE_URL}?APPID=${APP_ID}&lang=en&units=metric&q=${TARGET_CITY_NAME},jp`
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            weatherData = await response.json();
            // 新しいデータをキャッシュに保存
            WeatherCache.setWeatherData(weatherData);
        }

        updateWeatherUI(weatherData);
    } catch (error) {
        console.error(error);
    }
};

/**
 * 天気のUIを更新する関数だよ
 * @param {HTMLElement} container - 天気を表示する要素
 * @param {Object} data - 天気データ
 */
const updateWeatherUI = (data) => {
    const parent = document.querySelector(".Intel__wea");

    if (parent) {
        // HTML要素に値を設定
        parent.querySelector(
            ".weather"
        ).textContent = `${data.weather[0].description}`;
        parent.querySelector(".temp").textContent = `${Math.round(
            data.main.temp
        )}℃`;
        parent.querySelector(".humidity").textContent = `${Math.round(
            data.main.humidity
        )}%`;
    }
};

showWeather();
